module.exports = __webpack_public_path__ + "static/media/miota.f36dd737.png";